var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Loader2",
    imageRendering: "auto",
    baseProfile: "basic",
    x: "0px",
    y: "0px",
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "Tween-15",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-main)",
    stroke: "none",
    d: "M13.65 -13.65Q8.25 -19.3 0 -19.3 -8.05 -19.3 -13.65 -13.65 -19.3 -8.05 -19.3 0 -19.3 8.05 -13.65 13.65 -8.05 19.3 0 19.3 8.05 19.3 13.65 13.65 19.3 8.05 19.3 0 19.3 -8.05 13.65 -13.65M5.2 -9.65L8.45 -9.65 3 1.2 5.85 1.2 5.85 3.2 1.8 3.2 1.4 4.4 1.4 5.6 5.85 5.6 5.85 7.65 1.4 7.65 1.4 12.85 -1.6 12.85 -1.6 7.25 -6.05 7.25 -6.05 5.2 -1.6 5.2 -1.6 4 -2 2.8 -5.65 2.8 -5.65 1.2 -2.8 1.2 -8.45 -9.65 -5.25 -9.65 0 1.2 5.2 -9.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-symbols)",
    stroke: "none",
    d: "M8.45 -9.65L5.2 -9.65 0 1.2 -5.25 -9.65 -8.45 -9.65 -2.8 1.2 -5.65 1.2 -5.65 2.8 -2 2.8 -1.6 4 -1.6 5.2 -6.05 5.2 -6.05 7.25 -1.6 7.25 -1.6 12.85 1.4 12.85 1.4 7.65 5.85 7.65 5.85 5.6 1.4 5.6 1.4 4.4 1.8 3.2 5.85 3.2 5.85 1.2 3 1.2 8.45 -9.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tween-17",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-main)",
    stroke: "none",
    d: "M13.75 -13.65Q8.15 -19.3 .1 -19.3 -8.15 -19.3 -13.75 -13.65 -19.4 -8.05 -19.4 0 -19.4 8.05 -13.75 13.65 -7.95 19.3 .1 19.3 8.15 19.3 13.75 13.65 19.4 8.05 19.4 0 19.4 -8.05 13.75 -13.65M.7 -11.25Q8.15 -11.25 8.15 -3.2L5.35 -3.2Q5.35 -8.85 .7 -8.85 -1.1 -8.85 -2.3 -7.65 -3.7 -6.65 -3.7 -4.85 -3.7 -3.2 -2.1 0L2.7 0 2.7 1.2 -1.7 1.2Q-.9 2.8 -.9 3.6 -.9 7.05 -4.5 9.25 -2.1 8.45 -1.3 8.45L3.95 9.05Q5.75 9.05 6.75 8.05L7.95 10.05Q5.95 11.65 3.5 11.65 2.7 11.65 .3 10.85 -2.1 10.05 -2.9 10.05 -4.1 10.05 -5.9 11.25L-7.55 9.25Q-4.3 6.85 -4.3 3.6 -4.3 2.4 -5.1 .8L-7.95 .8 -7.95 0 -4.9 0Q-6.55 -2.4 -6.55 -4.85 -6.55 -7.85 -4.3 -9.45 -2.3 -11.25 .7 -11.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-symbols)",
    stroke: "none",
    d: "M8.15 -3.2Q8.15 -11.25 .7 -11.25 -2.3 -11.25 -4.3 -9.45 -6.55 -7.85 -6.55 -4.85 -6.55 -2.4 -4.9 0L-7.95 0 -7.95 .8 -5.1 .8Q-4.3 2.4 -4.3 3.6 -4.3 6.85 -7.55 9.25L-5.9 11.25Q-4.1 10.05 -2.9 10.05 -2.1 10.05 .3 10.85 2.7 11.65 3.5 11.65 5.95 11.65 7.95 10.05L6.75 8.05Q5.75 9.05 3.95 9.05L-1.3 8.45Q-2.1 8.45 -4.5 9.25 -.9 7.05 -.9 3.6 -.9 2.8 -1.7 1.2L2.7 1.2 2.7 0 -2.1 0Q-3.7 -3.2 -3.7 -4.85 -3.7 -6.65 -2.3 -7.65 -1.1 -8.85 .7 -8.85 5.35 -8.85 5.35 -3.2L8.15 -3.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tween-19",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-main)",
    stroke: "none",
    d: "M13.7 -13.7Q8.05 -19.3 .05 -19.3 -8 -19.3 -13.65 -13.7 -19.25 -8.05 -19.25 0 -19.25 8 -13.65 13.65 -8 19.3 .05 19.3 8.05 19.3 13.7 13.65 19.3 8 19.3 0 19.3 -8.05 13.7 -13.7M4.45 -6.45Q2.25 -8.45 .05 -8.45 -2 -8.45 -4 -6.45 -5 -5.05 -5.6 -2.45L3.25 -2.45 2.45 -.4 -5.6 -.4 -5.6 1.2 2.05 1.2 1.25 3.2 -5.6 3.2Q-4.4 10.05 .45 10.05 2.45 10.05 3.25 9.65L5.25 8 5.25 10.85Q3.45 12.05 .45 12.05 -7.2 12.05 -8.6 2.8L-10.85 2.8 -10 .8 -8.4 .8 -8.4 -.8 -10.85 -.8 -10 -2.85 -8.4 -2.85Q-8 -5.85 -5.6 -8.85 -3.2 -11.25 .45 -11.25 2.65 -11.25 6.05 -9.25L4.45 -6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-symbols)",
    stroke: "none",
    d: "M.05 -8.45Q2.25 -8.45 4.45 -6.45L6.05 -9.25Q2.65 -11.25 .45 -11.25 -3.2 -11.25 -5.6 -8.85 -8 -5.85 -8.4 -2.85L-10 -2.85 -10.85 -.8 -8.4 -.8 -8.4 .8 -10 .8 -10.85 2.8 -8.6 2.8Q-7.2 12.05 .45 12.05 3.45 12.05 5.25 10.85L5.25 8 3.25 9.65Q2.45 10.05 .45 10.05 -4.4 10.05 -5.6 3.2L1.25 3.2 2.05 1.2 -5.6 1.2 -5.6 -.4 2.45 -.4 3.25 -2.45 -5.6 -2.45Q-5 -5.05 -4 -6.45 -2 -8.45 .05 -8.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tween-21",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-main)",
    stroke: "none",
    d: "M13.6 -13.65Q8.15 -19.3 .1 -19.3 -7.9 -19.3 -13.55 -13.65 -19.2 -8.05 -19.2 0 -19.2 8.05 -13.55 13.65 -7.9 19.3 .1 19.3 8.15 19.3 13.6 13.65 19.2 8.05 19.2 0 19.2 -8.05 13.6 -13.65M5.15 -12.45L7.55 -12.45 6.95 -10.45 4.95 -10.45Q3.15 -10.45 2.95 -8.85L2.15 -4.45 5.15 -4.45 4.95 -2.4 1.7 -2.4 .1 7.25Q-.7 11.45 -1.9 13.05 -3.1 14.45 -5.9 14.45L-7.9 14.45 -7.7 12.05Q-5.3 12.05 -4.5 11.45 -3.7 10.85 -3.3 8.85L-1.3 -2.4 -3.9 -2.4 -3.7 -4.45 -.5 -4.45 .3 -8.45Q.9 -12.45 5.15 -12.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-symbols)",
    stroke: "none",
    d: "M7.55 -12.45L5.15 -12.45Q.9 -12.45 .3 -8.45L-.5 -4.45 -3.7 -4.45 -3.9 -2.4 -1.3 -2.4 -3.3 8.85Q-3.7 10.85 -4.5 11.45 -5.3 12.05 -7.7 12.05L-7.9 14.45 -5.9 14.45Q-3.1 14.45 -1.9 13.05 -.7 11.45 .1 7.25L1.7 -2.4 4.95 -2.4 5.15 -4.45 2.15 -4.45 2.95 -8.85Q3.15 -10.45 4.95 -10.45L6.95 -10.45 7.55 -12.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tween-23",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-main)",
    stroke: "none",
    d: "M-.1 -19.3Q-8.1 -19.3 -13.55 -13.7 -19.2 -8.05 -19.2 0 -19.2 8 -13.55 13.65 -8.1 19.3 -.1 19.3 7.95 19.3 13.6 13.65 19.2 8 19.2 0 19.2 -8.05 13.6 -13.7 8.15 -19.3 -.1 -19.3M.9 -13.7L.9 -11.7Q5.55 -11.05 6.95 -5.65L4.35 -5.65Q3.75 -8.65 .9 -9.25L.9 -1.65 2.95 -1.2Q7.75 .2 7.75 4.4 7.75 10.65 .9 11.25L.9 13.65 -.7 13.65 -.7 11.25Q-7.7 10.65 -7.7 4L-5.1 4 -5.1 4.4Q-5.1 8.4 -.7 9.25L-.7 1.2Q-4.3 .2 -5.5 -.8 -7.1 -2.25 -7.1 -4.85 -7.1 -7.45 -5.3 -9.45 -3.3 -11.25 -.7 -11.25L-.7 -13.7 .9 -13.7M.9 9.25Q4.95 9.25 4.95 5.2 4.95 2.2 .9 1.6L.9 9.25M-.7 -8.85Q-4.3 -8.05 -4.3 -5.25 -4.3 -3.05 -.7 -1.65L-.7 -8.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-symbols)",
    stroke: "none",
    d: "M.9 -11.7L.9 -13.7 -.7 -13.7 -.7 -11.25Q-3.3 -11.25 -5.3 -9.45 -7.1 -7.45 -7.1 -4.85 -7.1 -2.25 -5.5 -.8 -4.3 .2 -.7 1.2L-.7 9.25Q-5.1 8.4 -5.1 4.4L-5.1 4 -7.7 4Q-7.7 10.65 -.7 11.25L-.7 13.65 .9 13.65 .9 11.25Q7.75 10.65 7.75 4.4 7.75 .2 2.95 -1.2L.9 -1.65 .9 -9.25Q3.75 -8.65 4.35 -5.65L6.95 -5.65Q5.55 -11.05 .9 -11.7M-4.3 -5.25Q-4.3 -8.05 -.7 -8.85L-.7 -1.65Q-4.3 -3.05 -4.3 -5.25M4.95 5.2Q4.95 9.25 .9 9.25L.9 1.6Q4.95 2.2 4.95 5.2Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scene-1",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Tween-23",
    transform: "translate(173.35 78.65)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.583;.771;1",
    values: "173.35,78.65;173.35,78.65;99.55,88.25;99.55,88.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.583;.771;1",
    values: "1;1;0;0"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.583;.979;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Tween-23",
    transform: "translate(102.2 25.6)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.354;.375;.396;.417;.438;.458;.479;.5;.521;.542;.563;1",
    values: "102.2,25.6;102.2,25.6;111.9,25.7;121.6,27.3;131.1,30.25;140.15,34.4;148.6,39.7;156.15,45.95;162.6,53.1;167.75,61;171.4,69.55;173.35,78.65;173.35,78.65"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.354;.583;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tween-22",
    transform: "translate(102.05 91.75)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;.208;.229;.25;.271;.292;.313;.333;1",
    values: "102.05,91.75;102.05,91.75;102.05,78.8;102.05,65.85;102.1,52.95;102.1,39.95;102.15,35.2;102.15,30.4;102.2,25.6;102.2,25.6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;.208;.229;.25;.271;.292;.313;.333;1",
    values: "0;0;.14;.28;.42;.57;.71;.85;1;1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-main)",
    stroke: "none",
    d: "M-.1 -19.3Q-8.1 -19.3 -13.55 -13.7 -19.2 -8.05 -19.2 0 -19.2 8 -13.55 13.65 -8.1 19.3 -.1 19.3 7.95 19.3 13.6 13.65 19.2 8 19.2 0 19.2 -8.05 13.6 -13.7 8.15 -19.3 -.1 -19.3M.9 -13.7L.9 -11.7Q5.55 -11.05 6.95 -5.65L4.35 -5.65Q3.75 -8.65 .9 -9.25L.9 -1.65 2.95 -1.2Q7.75 .2 7.75 4.4 7.75 10.65 .9 11.25L.9 13.65 -.7 13.65 -.7 11.25Q-7.7 10.65 -7.7 4L-5.1 4 -5.1 4.4Q-5.1 8.4 -.7 9.25L-.7 1.2Q-4.3 .2 -5.5 -.8 -7.1 -2.25 -7.1 -4.85 -7.1 -7.45 -5.3 -9.45 -3.3 -11.25 -.7 -11.25L-.7 -13.7 .9 -13.7M.9 9.25Q4.95 9.25 4.95 5.2 4.95 2.2 .9 1.6L.9 9.25M-.7 -8.85Q-4.3 -8.05 -4.3 -5.25 -4.3 -3.05 -.7 -1.65L-.7 -8.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-symbols)",
    stroke: "none",
    d: "M.9 -11.7L.9 -13.7 -.7 -13.7 -.7 -11.25Q-3.3 -11.25 -5.3 -9.45 -7.1 -7.45 -7.1 -4.85 -7.1 -2.25 -5.5 -.8 -4.3 .2 -.7 1.2L-.7 9.25Q-5.1 8.4 -5.1 4.4L-5.1 4 -7.7 4Q-7.7 10.65 -.7 11.25L-.7 13.65 .9 13.65 .9 11.25Q7.75 10.65 7.75 4.4 7.75 .2 2.95 -1.2L.9 -1.65 .9 -9.25Q3.75 -8.65 4.35 -5.65L6.95 -5.65Q5.55 -11.05 .9 -11.7M-4.3 -5.25Q-4.3 -8.05 -.7 -8.85L-.7 -1.65Q-4.3 -3.05 -4.3 -5.25M4.95 5.2Q4.95 9.25 .9 9.25L.9 1.6Q4.95 2.2 4.95 5.2Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;.354;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Tween-21",
    transform: "translate(160.8 158)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.583;.771;1",
    values: "160.8,158;160.8,158;99.55,88.25;99.55,88.25"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.583;.771;1",
    values: "1;1;0;0"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.583;.979;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Tween-21",
    transform: "translate(173.35 78.65)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.354;.375;.396;.417;.438;.458;.479;.5;.521;.542;.563;1",
    values: "173.35,78.65;173.35,78.65;175.4,92.2;176.05,103.3;175.75,112.85;174.8,121.35;173.35,128.95;171.55,135.85;169.3,142.15;166.8,147.95;164,153.25;160.8,158;160.8,158"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.354;.583;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tween-20",
    transform: "translate(102.05 91.75)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;.208;.229;.25;.271;.292;.313;.333;1",
    values: "102.05,91.75;102.05,91.75;115.45,89.55;128.9,87.35;142.35,85.1;155.8,82.9;161.65,81.5;167.5,80.1;173.35,78.65;173.35,78.65"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;.208;.229;.25;.271;.292;.313;.333;1",
    values: "0;0;.14;.28;.42;.57;.71;.85;1;1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-main)",
    stroke: "none",
    d: "M13.6 -13.65Q8.15 -19.3 .1 -19.3 -7.9 -19.3 -13.55 -13.65 -19.2 -8.05 -19.2 0 -19.2 8.05 -13.55 13.65 -7.9 19.3 .1 19.3 8.15 19.3 13.6 13.65 19.2 8.05 19.2 0 19.2 -8.05 13.6 -13.65M5.15 -12.45L7.55 -12.45 6.95 -10.45 4.95 -10.45Q3.15 -10.45 2.95 -8.85L2.15 -4.45 5.15 -4.45 4.95 -2.4 1.7 -2.4 .1 7.25Q-.7 11.45 -1.9 13.05 -3.1 14.45 -5.9 14.45L-7.9 14.45 -7.7 12.05Q-5.3 12.05 -4.5 11.45 -3.7 10.85 -3.3 8.85L-1.3 -2.4 -3.9 -2.4 -3.7 -4.45 -.5 -4.45 .3 -8.45Q.9 -12.45 5.15 -12.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-symbols)",
    stroke: "none",
    d: "M7.55 -12.45L5.15 -12.45Q.9 -12.45 .3 -8.45L-.5 -4.45 -3.7 -4.45 -3.9 -2.4 -1.3 -2.4 -3.3 8.85Q-3.7 10.85 -4.5 11.45 -5.3 12.05 -7.7 12.05L-7.9 14.45 -5.9 14.45Q-3.1 14.45 -1.9 13.05 -.7 11.45 .1 7.25L1.7 -2.4 4.95 -2.4 5.15 -4.45 2.15 -4.45 2.95 -8.85Q3.15 -10.45 4.95 -10.45L6.95 -10.45 7.55 -12.45Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;.354;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Tween-19",
    transform: "translate(42.9 158)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.583;.771;1",
    values: "42.9,158;42.9,158;102.5,91;102.5,91"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.583;.771;1",
    values: "1;1;0;0"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.583;.979;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Tween-19",
    transform: "translate(160.8 158)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.354;.375;.396;.417;.438;.458;.479;.5;.521;.542;.563;1",
    values: "160.8,158;160.8,158;152.25,165.15;141.95,170.85;130.4,175.1;117.85,177.75;104.75,178.85;91.4,178.25;78.2,175.95;65.45,171.8;53.55,165.85;42.85,158;42.85,158"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.354;.583;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tween-18",
    transform: "translate(102.1 91.75)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;.208;.229;.25;.271;.292;.313;.333;1",
    values: "102.1,91.75;102.1,91.75;112.3,103.85;122.55,116;132.8,128.1;143.05,140.25;148.95,146.15;154.85,152.05;160.8,158;160.8,158"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;.208;.229;.25;.271;.292;.313;.333;1",
    values: "0;0;.14;.28;.42;.57;.71;.85;1;1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-main)",
    stroke: "none",
    d: "M13.7 -13.7Q8.05 -19.3 .05 -19.3 -8 -19.3 -13.65 -13.7 -19.25 -8.05 -19.25 0 -19.25 8 -13.65 13.65 -8 19.3 .05 19.3 8.05 19.3 13.7 13.65 19.3 8 19.3 0 19.3 -8.05 13.7 -13.7M4.45 -6.45Q2.25 -8.45 .05 -8.45 -2 -8.45 -4 -6.45 -5 -5.05 -5.6 -2.45L3.25 -2.45 2.45 -.4 -5.6 -.4 -5.6 1.2 2.05 1.2 1.25 3.2 -5.6 3.2Q-4.4 10.05 .45 10.05 2.45 10.05 3.25 9.65L5.25 8 5.25 10.85Q3.45 12.05 .45 12.05 -7.2 12.05 -8.6 2.8L-10.85 2.8 -10 .8 -8.4 .8 -8.4 -.8 -10.85 -.8 -10 -2.85 -8.4 -2.85Q-8 -5.85 -5.6 -8.85 -3.2 -11.25 .45 -11.25 2.65 -11.25 6.05 -9.25L4.45 -6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-symbols)",
    stroke: "none",
    d: "M.05 -8.45Q2.25 -8.45 4.45 -6.45L6.05 -9.25Q2.65 -11.25 .45 -11.25 -3.2 -11.25 -5.6 -8.85 -8 -5.85 -8.4 -2.85L-10 -2.85 -10.85 -.8 -8.4 -.8 -8.4 .8 -10 .8 -10.85 2.8 -8.6 2.8Q-7.2 12.05 .45 12.05 3.45 12.05 5.25 10.85L5.25 8 3.25 9.65Q2.45 10.05 .45 10.05 -4.4 10.05 -5.6 3.2L1.25 3.2 2.05 1.2 -5.6 1.2 -5.6 -.4 2.45 -.4 3.25 -2.45 -5.6 -2.45Q-5 -5.05 -4 -6.45 -2 -8.45 .05 -8.45Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;.354;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Tween-17",
    transform: "translate(27.15 79.45)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.583;.771;1",
    values: "27.15,79.45;27.15,79.45;102.4,91;102.4,91"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.583;.771;1",
    values: "1;1;0;0"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.583;.979;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Tween-17",
    transform: "translate(42.85 158)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.354;.375;.396;.417;.438;.458;.479;.5;.521;.542;.563;1",
    values: "42.85,158;42.85,158;37.25,148.45;33.4,139.65;30.65,131.35;28.7,123.35;27.35,115.65;26.5,108.2;26.1,100.9;26,93.8;26.35,86.8;27,80;27,80"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.354;.583;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tween-16",
    transform: "translate(102 91.75)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;.208;.229;.25;.271;.292;.313;.333;1",
    values: "102,91.75;102,91.75;91.1,103.85;80.15,116;69.2,128.1;58.25,140.25;53.15,146.15;48,152.05;42.85,158;42.85,158"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;.208;.229;.25;.271;.292;.313;.333;1",
    values: "0;0;.14;.28;.42;.57;.71;.85;1;1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-main)",
    stroke: "none",
    d: "M13.75 -13.65Q8.15 -19.3 .1 -19.3 -8.15 -19.3 -13.75 -13.65 -19.4 -8.05 -19.4 0 -19.4 8.05 -13.75 13.65 -7.95 19.3 .1 19.3 8.15 19.3 13.75 13.65 19.4 8.05 19.4 0 19.4 -8.05 13.75 -13.65M.7 -11.25Q8.15 -11.25 8.15 -3.2L5.35 -3.2Q5.35 -8.85 .7 -8.85 -1.1 -8.85 -2.3 -7.65 -3.7 -6.65 -3.7 -4.85 -3.7 -3.2 -2.1 0L2.7 0 2.7 1.2 -1.7 1.2Q-.9 2.8 -.9 3.6 -.9 7.05 -4.5 9.25 -2.1 8.45 -1.3 8.45L3.95 9.05Q5.75 9.05 6.75 8.05L7.95 10.05Q5.95 11.65 3.5 11.65 2.7 11.65 .3 10.85 -2.1 10.05 -2.9 10.05 -4.1 10.05 -5.9 11.25L-7.55 9.25Q-4.3 6.85 -4.3 3.6 -4.3 2.4 -5.1 .8L-7.95 .8 -7.95 0 -4.9 0Q-6.55 -2.4 -6.55 -4.85 -6.55 -7.85 -4.3 -9.45 -2.3 -11.25 .7 -11.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-symbols)",
    stroke: "none",
    d: "M8.15 -3.2Q8.15 -11.25 .7 -11.25 -2.3 -11.25 -4.3 -9.45 -6.55 -7.85 -6.55 -4.85 -6.55 -2.4 -4.9 0L-7.95 0 -7.95 .8 -5.1 .8Q-4.3 2.4 -4.3 3.6 -4.3 6.85 -7.55 9.25L-5.9 11.25Q-4.1 10.05 -2.9 10.05 -2.1 10.05 .3 10.85 2.7 11.65 3.5 11.65 5.95 11.65 7.95 10.05L6.75 8.05Q5.75 9.05 3.95 9.05L-1.3 8.45Q-2.1 8.45 -4.5 9.25 -.9 7.05 -.9 3.6 -.9 2.8 -1.7 1.2L2.7 1.2 2.7 0 -2.1 0Q-3.7 -3.2 -3.7 -4.85 -3.7 -6.65 -2.3 -7.65 -1.1 -8.85 .7 -8.85 5.35 -8.85 5.35 -3.2L8.15 -3.2Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;.354;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Tween-15",
    transform: "translate(102.2 25.6)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.583;.771;1",
    values: "102.2,25.6;102.2,25.6;102.3,91;102.3,91"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.583;.771;1",
    values: "1;1;0;0"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.583;.979;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Tween-15",
    transform: "translate(26.95 79.45)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.354;.375;.396;.417;.438;.458;.479;.5;.521;.542;.563;1",
    values: "26.95,79.45;26.95,79.45;33.5,64.05;40.5,53;47.75,44.75;55.2,38.4;62.8,33.65;70.5,30.05;78.25,27.55;86.15,26;94.1,25.3;102.2,25.6;102.2,25.6"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.354;.583;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tween-14",
    transform: "translate(102.1 91.75)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    additive: "replace",
    type: "translate",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;.208;.229;.25;.271;.292;.313;.333;1",
    values: "102.1,91.75;102.1,91.75;88.4,89.65;74.65,87.5;60.9,85.4;47.15,83.25;40.45,82;33.75,80.75;27,79.5;27,79.5"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;.208;.229;.25;.271;.292;.313;.333;1",
    values: "0;0;.14;.28;.42;.57;.71;.85;1;1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-main)",
    stroke: "none",
    d: "M13.65 -13.65Q8.25 -19.3 0 -19.3 -8.05 -19.3 -13.65 -13.65 -19.3 -8.05 -19.3 0 -19.3 8.05 -13.65 13.65 -8.05 19.3 0 19.3 8.05 19.3 13.65 13.65 19.3 8.05 19.3 0 19.3 -8.05 13.65 -13.65M5.2 -9.65L8.45 -9.65 3 1.2 5.85 1.2 5.85 3.2 1.8 3.2 1.4 4.4 1.4 5.6 5.85 5.6 5.85 7.65 1.4 7.65 1.4 12.85 -1.6 12.85 -1.6 7.25 -6.05 7.25 -6.05 5.2 -1.6 5.2 -1.6 4 -2 2.8 -5.65 2.8 -5.65 1.2 -2.8 1.2 -8.45 -9.65 -5.25 -9.65 0 1.2 5.2 -9.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-symbols)",
    stroke: "none",
    d: "M8.45 -9.65L5.2 -9.65 0 1.2 -5.25 -9.65 -8.45 -9.65 -2.8 1.2 -5.65 1.2 -5.65 2.8 -2 2.8 -1.6 4 -1.6 5.2 -6.05 5.2 -6.05 7.25 -1.6 7.25 -1.6 12.85 1.4 12.85 1.4 7.65 5.85 7.65 5.85 5.6 1.4 5.6 1.4 4.4 1.8 3.2 5.85 3.2 5.85 1.2 3 1.2 8.45 -9.65Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;.354;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tween-13",
    transform: "translate(101.9 106.75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-main)",
    stroke: "none",
    d: "M-6.8 45.45Q-4 48.25 -.4 48.25 3.25 48.25 6.05 45.45L-6.8 45.45M10.25 43.85Q11.85 43.85 12.9 42.85 13.9 41.85 13.9 40.25 13.9 38.8 12.9 37.6 11.85 36.6 10.25 36.6L-11.45 36.6Q-14.85 36.6 -14.85 40.25 -14.85 43.85 -11.45 43.85L10.25 43.85M12.9 34Q13.9 33 13.9 31.4 14.1 30 12.9 28.75 11.85 27.75 10.25 27.75L-11.45 27.75Q-14.85 27.75 -14.85 31.4 -14.85 35 -11.45 35L10.25 35Q11.85 35 12.9 34M23.55 -1Q30.15 -12.45 30.15 -18.05 29.75 -30.5 20.9 -39.35 12.1 -48.2 -.4 -48.2 -12.65 -48.2 -21.5 -39.35 -30.15 -30.5 -30.15 -18.05 -30.15 -12.45 -23.5 -1 -16.85 10.3 -16.85 13.3L-16.85 19.3Q-16.85 21.75 -15.05 23.55 -13.25 25.35 -10.85 25.35L10.65 25.35Q13.1 25.35 14.9 23.55 16.7 21.75 16.7 19.3L16.7 13.3Q16.7 10.3 23.55 -1Z",
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.979;1",
    values: "none;inline;inline"
  })), /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tween-12",
    transform: "translate(101.9 106.75)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.79199;.979;1",
    values: "1;1;0;0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-main)",
    stroke: "none",
    d: "M-6.8 45.45Q-4 48.25 -.4 48.25 3.25 48.25 6.05 45.45L-6.8 45.45M10.25 43.85Q11.85 43.85 12.9 42.85 13.9 41.85 13.9 40.25 13.9 38.8 12.9 37.6 11.85 36.6 10.25 36.6L-11.45 36.6Q-14.85 36.6 -14.85 40.25 -14.85 43.85 -11.45 43.85L10.25 43.85M12.9 34Q13.9 33 13.9 31.4 14.1 30 12.9 28.75 11.85 27.75 10.25 27.75L-11.45 27.75Q-14.85 27.75 -14.85 31.4 -14.85 35 -11.45 35L10.25 35Q11.85 35 12.9 34M23.55 -1Q30.15 -12.45 30.15 -18.05 29.75 -30.5 20.9 -39.35 12.1 -48.2 -.4 -48.2 -12.65 -48.2 -21.5 -39.35 -30.15 -30.5 -30.15 -18.05 -30.15 -12.45 -23.5 -1 -16.85 10.3 -16.85 13.3L-16.85 19.3Q-16.85 21.75 -15.05 23.55 -13.25 25.35 -10.85 25.35L10.65 25.35Q13.1 25.35 14.9 23.55 16.7 21.75 16.7 19.3L16.7 13.3Q16.7 10.3 23.55 -1Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;.979;1",
    values: "none;inline;none;none"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Tween-11",
    transform: "translate(101.9 106.75)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;1",
    values: "0;1;1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--loader-main)",
    stroke: "none",
    d: "M-6.8 45.45Q-4 48.25 -.4 48.25 3.25 48.25 6.05 45.45L-6.8 45.45M10.25 43.85Q11.85 43.85 12.9 42.85 13.9 41.85 13.9 40.25 13.9 38.8 12.9 37.6 11.85 36.6 10.25 36.6L-11.45 36.6Q-14.85 36.6 -14.85 40.25 -14.85 43.85 -11.45 43.85L10.25 43.85M12.9 34Q13.9 33 13.9 31.4 14.1 30 12.9 28.75 11.85 27.75 10.25 27.75L-11.45 27.75Q-14.85 27.75 -14.85 31.4 -14.85 35 -11.45 35L10.25 35Q11.85 35 12.9 34M23.55 -1Q30.15 -12.45 30.15 -18.05 29.75 -30.5 20.9 -39.35 12.1 -48.2 -.4 -48.2 -12.65 -48.2 -21.5 -39.35 -30.15 -30.5 -30.15 -18.05 -30.15 -12.45 -23.5 -1 -16.85 10.3 -16.85 13.3L-16.85 19.3Q-16.85 21.75 -15.05 23.55 -13.25 25.35 -10.85 25.35L10.65 25.35Q13.1 25.35 14.9 23.55 16.7 21.75 16.7 19.3L16.7 13.3Q16.7 10.3 23.55 -1Z"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "display",
    repeatCount: "indefinite",
    dur: "2s",
    keyTimes: "0;.188;1",
    values: "inline;none;none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.8281a2fb.svg";
export { ForwardRef as ReactComponent };